import { KeyboardArrowRightOutlined } from '@mui/icons-material'
import { Box, styled, useTheme } from '@mui/material'
import { useState } from 'react'
import AccordionCommon from 'src/components/AccordionCommon'
import { IComponentFilters } from 'src/generated-types'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import ProductListContainer from './ProductListContainer'

interface ILocationDetailAccordionProps {
  localityName: string
  mooringName: string
  customerId: EntityId
  localityId: EntityId
  mooringId: EntityId
  filters: IComponentFilters
}
const LocationDetailAccordion: React.FC<ILocationDetailAccordionProps> = ({
  localityName,
  mooringName,
  customerId,
  localityId,
  mooringId,
  filters,
}) => {
  const [expanded, setExpanded] = useState(false)
  const theme = useTheme()

  return (
    <StyledAccordion
      title={<Box paddingLeft={1}>{`${localityName} ( ${mooringName} )`}</Box>}
      expandedIcon={<KeyboardArrowRightOutlined fontSize="medium" />}
      expandedBottomMargin={'0px'}
      expandedTopMargin={'0px'}
      onChange={() => setExpanded(!expanded)}
      bgColor={getThemeColor(theme, MUIThemeColors.backgroundMain)}
    >
      {expanded && (
        <ProductListContainer
          customerId={customerId}
          localityId={localityId}
          mooringId={mooringId}
          localityName={localityName}
          filters={filters}
        />
      )}
    </StyledAccordion>
  )
}

export default LocationDetailAccordion

const StyledAccordion = styled(AccordionCommon)(({ theme }) => ({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(50deg)',
  },
}))
